<template>
  <div>
    <p class="text-center" style="margin-bottom:12px;">全部预约记录</p>
    <div class="box_down">
      <template v-if="pavilionAppoints.length > 0">
        <el-card v-for="appoint in pavilionAppoints" :key="appoint.id"
                 class="box-card"
                 @click.native="goPavilionAppointDetails(appoint)">
          <div slot="header">
            <el-row :gutter="10">
              <el-col :span="8" style="text-align:right;">预约时间</el-col>
              <el-col :span="16" style="text-align:left;font-weight:bold;">{{ appoint.appointDate }}
                {{ appoint.startTime }}-{{ appoint.endTime }}
              </el-col>
            </el-row>
          </div>
          <div class="teacherInfo relative">
            <el-row :gutter="10">
              <el-col :span="5">
                <el-avatar
                  shape="square"
                  :size="windowInnerWidth * 0.25"
                  :src="appoint.imgUrl"
                ></el-avatar>
              </el-col>
              <el-col :span="19">
                <el-row :gutter="10" style="margin:10px;">
                  <el-col :span="6" style="text-align:right;">地点</el-col>
                  <el-col :span="18" style="text-align:left;font-weight:bold;">{{ appoint.pavilionPlace }}</el-col>
                </el-row>
                <el-row :gutter="10" style="margin:10px;">
                  <el-col :span="6" style="text-align:right;">面试亭</el-col>
                  <el-col :span="18" style="text-align:left;font-weight:bold;">{{ appoint.pavilionName }}</el-col>
                </el-row>
                <el-row :gutter="10" style="margin:10px;">
                  <el-col :span="6" style="text-align:right;">密码</el-col>
                  <el-col :span="18" style="text-align:left;font-weight:bold;">
                    {{ isShowKey(appoint) ? `${appoint.secretKey.openPwd}#` : '空' }}
                  </el-col>
                </el-row>
<!--                <el-row :gutter="10" style="margin:10px;">-->
<!--                  <el-col :span="6" style="text-align:right;">二维码</el-col>-->
<!--                  <el-col :span="18" style="text-align:left;font-weight:bold;" v-if="isShowKey(appoint)">-->
<!--                    <qrcode-vue :value="appoint.secretKey.qrPwd" :size="windowInnerWidth * 0.3"/>-->
<!--                  </el-col>-->
<!--                  <el-col :span="18" style="text-align:left;font-weight:bold;" v-else>-->
<!--                    空-->
<!--                  </el-col>-->
<!--                </el-row>-->
              </el-col>
            </el-row>
          </div>
          <div class="clear mt10">
            <p class="text-center" style="margin-bottom:0px;"></p>
            <p class="text-center" :class="getStuSmartPavilionAppointStatusClass(appoint.status)">
              {{ getStuSmartPavilionAppointStatusName(appoint.status) }}</p>
          </div>
        </el-card>
      </template>
      <el-empty v-else description="暂无预约"/>
    </div>
    <el-button type="primary" round class="button_down" @click="goSmartPavilion">我要预约
    </el-button>
  </div>
</template>

<script>
import {mapState} from "vuex";
import HttpRequest from "@/utils/request";
import QrcodeVue from "qrcode.vue";
import {
  getStuSmartPavilionAppointStatusClass,
  getStuSmartPavilionAppointStatusName,
  isShowKey
} from "@/assets/js/pavilion";

export default {
  components: {
    QrcodeVue,
  },
  data() {
    return {
      windowInnerWidth: 0,
      pavilionAppoints: []
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  activated() {
    this.getStuPavilionAppointByWhile();
  },
  mounted() {
    this.windowInnerWidth = window.innerWidth
    document.title = '面试亭'
    this.getStuPavilionAppointByWhile();
  },
  methods: {
    isShowKey,
    getStuSmartPavilionAppointStatusClass,
    getStuSmartPavilionAppointStatusName,
    getStuPavilionAppointByWhile() {
      let url = "/constub/pavilionAppoint/getStuPavilionAppointByWhile";
      let data = {token: this.student.token};
      HttpRequest.requestFormPost(url, data).then((res) => {
        if (res && res.result.success) {
          this.pavilionAppoints = res.data;
        } else {
          this.$message({
            message: res.result.message,
            type: 'warning'
          });
        }
      });
    },
    goPavilionAppointDetails(appoint) {
      this.$router.push({path: '/pavilionAppointDetails', query: { params: JSON.stringify(appoint)}});
    },
    goSmartPavilion() {
      this.$router.push('/smartPavilion')
    }
  },
};
</script>

<style scoped>
.box_down {
  z-index: 888;
  position: fixed;
  top: 25px;
  left: 0;
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(100% - 155px);
  overflow: auto;
}

.button_down {
  z-index: 999;
  position: fixed;
  bottom: 60px;
  left: 0;
  right: 10px;
  margin: 10px;
  width: calc(100% - 20px);
  overflow: auto;
}
</style>
